import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  calculatePaymentsParams,
  IDigitalRetailingState,
  VehicleRequestParams,
} from 'pages/digitalRetailing/DigitalRetailingInterface';
import { bookAnAppointmentAPI, calculatePaymentsAPI, getVehicleByVIN } from './ApiEndPoints';
import { handleApiError } from './CommonModuleState';

const initialState: IDigitalRetailingState = {
  loading: false,
  vehicleData: {},
  paymentData: {
    biweekly: 0,
    monthly: 0,
    weekly: 0,
  },
};

export const vehicleDetailsByVIN = createAsyncThunk(
  'digitalRetailing/vehicleDetailsByVIN',
  async (data: { requestParams: VehicleRequestParams; VIN: string }) => {
    try {
      const response = await axios.get(`${getVehicleByVIN}${data?.VIN}`, {
        params: data?.requestParams,
      });
      return response.data;
    } catch (error: unknown) {
      const errorMessage = handleApiError(error);
      throw new Error(errorMessage);
    }
  }
);

export const calculatePayments = createAsyncThunk(
  'digitalRetailing/calculatePayments',
  async (data: { requestParams: calculatePaymentsParams }) => {
    try {
      const response = await axios.get(calculatePaymentsAPI, {
        params: data?.requestParams,
      });
      return response.data;
    } catch (error: unknown) {
      const errorMessage = handleApiError(error);
      throw new Error(errorMessage);
    }
  }
);

export const bookAnAppointment = createAsyncThunk(
  'digitalRetailing/bookAnAppointment',
  async (data: { requestParams: calculatePaymentsParams; leadId: string }) => {
    try {
      const response = await axios.post(`${bookAnAppointmentAPI}${data?.leadId}`, data);

      return response.data;
    } catch (error: unknown) {
      const errorMessage = handleApiError(error);
      throw new Error(errorMessage);
    }
  }
);

export const digitalRetailingState = createSlice({
  name: 'digitalRetailing',
  initialState,
  reducers: {
    clearVehicleData: (state) => {
      return {
        ...state,
        vehicleData: initialState.vehicleData,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(vehicleDetailsByVIN.pending, (state) => {
        state.loading = true;
      })
      .addCase(vehicleDetailsByVIN.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleData = action.payload?.message;
      })
      .addCase(vehicleDetailsByVIN.rejected, (state, action) => {
        state.loading = false;
        state.vehicleData = {
          message: action.error.message,
          success: false,
        };
      })
      .addCase(calculatePayments.pending, (state) => {
        state.loading = true;
      })
      .addCase(calculatePayments.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentData = action.payload?.message;
      });
  },
});

// Action creators are generated for each case reducer function
export const { clearVehicleData } = digitalRetailingState.actions;
export default digitalRetailingState.reducer;
